// Performance-optimized button effects using IntersectionObserver
// Effects only run when buttons are visible in the viewport
function initButtonEffects() {
  var observer = window['ButtonEffectsObserver'];

  if (!observer) {
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!(entry.target instanceof HTMLElement)) return;
        var btn = entry.target;
        if (entry.isIntersecting) {
          // --- Shake effect for Add to Cart buttons ---
          if (btn.matches('button[name="add"]')) {
            // One-time setup: define trigger and schedule functions
            if (!btn.dataset['shakeInit']) {
              btn.dataset['shakeInit'] = 'true';
              btn['_triggerShake'] = function() {
                if (!btn.isConnected) return;
                btn.classList.remove('shake');
                void btn.offsetWidth;
                btn.classList.add('shake');
              };
              btn['_scheduleShake'] = function() {
                if (!btn.isConnected) return;
                var delay = Math.floor(Math.random() * 1500) + 1500; // Random delay between 1.5s and 3s
                btn['_shakeTimer'] = setTimeout(function() {
                  btn['_triggerShake']();
                  btn['_scheduleShake']();
                }, delay);
              };
            }
            // (Re)start timers if not already running (handles re-entry into viewport)
            if (!btn['_shakeTimer']) {
              btn['_shakeTimer'] = setTimeout(btn['_scheduleShake'], 1000);
            }
          }

          // --- Ray shine effect for accelerated checkout blocks ---
          if (btn.matches('.accelerated-checkout-block')) {
            // One-time setup: define trigger and schedule functions
            if (!btn.dataset['rayInit']) {
              btn.dataset['rayInit'] = 'true';
              btn['_triggerRay'] = function() {
                if (!btn.isConnected) return;
                btn.classList.remove('ray-shine');
                void btn.offsetWidth;
                btn.classList.add('ray-shine');
              };
              btn['_scheduleRay'] = function() {
                if (!btn.isConnected) return;
                var delay = Math.floor(Math.random() * 3000) + 4000; // Random delay between 4s and 7s (3.5s animation + gap)
                btn['_rayTimer'] = setTimeout(function() {
                  btn['_triggerRay']();
                  btn['_scheduleRay']();
                }, delay);
              };
            }
            // (Re)start timers if not already running (handles re-entry into viewport)
            if (!btn['_rayTimer']) {
              btn['_rayTimer'] = setTimeout(btn['_scheduleRay'], 2000);
            }
          }
        } else {
          // Stop timers when button leaves viewport (saves resources)
          if (btn['_shakeTimer']) { clearTimeout(btn['_shakeTimer']); btn['_shakeTimer'] = undefined; }
          if (btn['_rayTimer']) { clearTimeout(btn['_rayTimer']); btn['_rayTimer'] = undefined; }
        }
      });
    }, { threshold: 0.1 });

    window['ButtonEffectsObserver'] = observer;
  }

  // Observe all matching buttons (also catches new buttons from section reloads)
  document.querySelectorAll('button[name="add"], .accelerated-checkout-block').forEach(function(btn) {
    observer.observe(btn);
  });
}

document.addEventListener('DOMContentLoaded', initButtonEffects);
document.addEventListener('shopify:section:load', initButtonEffects);